import React, { useEffect, useRef } from 'react';
import { Box, ButtonLink, IconCloseRegular, Inline, Text3, skinVars } from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import './index.scss';
import { isDesktop } from 'react-device-detect';
import navigateParams from '../../utils/navigation/navigateParams';
import { hideSnackbarProfile } from '../../utils/store/features/user';

export type ISnackbarMessageData = {
    url?: string;
    timeout?: number;
};

export const SnackbarProfile: React.FC<ISnackbarMessageData> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const snackbar = useRef<HTMLDivElement>(null);
    const intervalSnackbar = useRef<number>();
    const intervalAnimation = useRef<number>();

    useEffect(() => {
        intervalAnimation.current = window.setTimeout(() => {
            snackbar.current?.classList.add('hide');
        }, 10000);

        () => {
            window.clearTimeout(intervalAnimation.current);
            window.clearTimeout(intervalSnackbar.current);
        };
    }, []);
    return (
        <div
            ref={snackbar}
            className='c-snackbar'
            style={{
                background: skinVars.colors.feedbackInfoBackground,
                animation: `${isDesktop ? 'fadeInDesktop' : 'fadeInMobile'} .3s ease-in-out forwards`,
            }}
        >
            <Box padding={12}>
                <Inline space={2} alignItems='center'>
                    <Text3 color={skinVars.colors.textPrimaryInverse} regular>
                        {t('snackBarProfileText')}
                    </Text3>
                    <div className='c-snackbar-text'>
                        <ButtonLink
                            onPress={() => {
                                dispatch(hideSnackbarProfile());
                                window.clearTimeout(intervalSnackbar.current);
                                window.clearTimeout(intervalAnimation.current);
                                if (navigateParams('navigation-global-profile', '', {}, '', '')) {
                                    navigate('/profile');
                                }
                            }}
                        >
                            <Text3 medium color={skinVars.colors.textLinkSnackbar}>
                                {t('snackBarProfileBtn')}
                            </Text3>
                        </ButtonLink>
                    </div>
                    <div
                        onClick={() => {
                            dispatch(hideSnackbarProfile());
                        }}
                    >
                        <IconCloseRegular size={24} color={skinVars.colors.background}></IconCloseRegular>
                    </div>
                </Inline>
            </Box>
        </div>
    );
};

export default SnackbarProfile;
